/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import CursoOpinionList from './CursoOpinionList';
import {bindActionCreators} from 'redux';
import * as cursoopinionActions from '../../actions/cursoopinionActions';
import * as paginaActions from '../../actions/paginaActions';
import toastr from 'toastr';
import ManageList from '../common/ManageList';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import {getMargenes} from '../../util/'; 
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';


class ManageCursoOpinionList extends ManageList  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            errors:{},
            strings:[],
            showActivos:true,
            filtrosCombo:{},
            permisos:{}
		};
	}

	componentDidMount(){
       
		window.scrollTo(0, 0);
       let pageInfo={
            page:'CursoOpinion',
            idioma:this.props.idioma 
         };
  this.props.showSidebarIzquierdaActions.sidebarIzquierda(true); 
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{
           this.setState({"permisos":pageInfoResponse.permisos,
                         "strings":pageInfoResponse.strings});
       })
        .catch(error=>{
          toastr.error(error);
        }); 
		this.inicializa();
	}
        
  
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 
		return (
            <Segment  style={margenes}>
                  
                <CursoOpinionList
                    strings={this.props.strings}
                    cursoopinion={this.props.listado.content}
                    activePage={this.props.listado.paginaActual+1}
                    handleSelectPagination={this.handleSelectPagination}
                    totalPages={this.props.listado.totalPages}
                    handleChange= {this.handleChangeFiltro}
                    filtro={this.state.filtro}
                    onFiltrarInformacion={this.onFiltrarInformacion}
                    filtroActivo={this.props.listado.filtroActivo}
                    filtroActual={this.props.listado.filtroActual}
                    onDesactivarFiltro={this.onDesactivarFiltro}
                    confirmarBorrado={this.confirmarBorrado}
                    onShowModalBorrar={this.onShowModalBorrar}
                    onShowModalActivar={this.onShowModalActivar}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    handleChangeFiltro= {this.handleChangeFiltro}
                    handleChangeActivos={this.handleChangeActivos}
                    showActivos={this.props.listado.showActivos}
                    color={this.props.color}
					 form={this.props.form}
                    permisos={this.state.permisos}

                />
            
                <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.borrar}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este registro de forma permanente?"}
                    titulo={this.state.strings?this.state.strings["CursoOpinion"]:""}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalActivar}
                    closeModal={this.oncloseModal}
                    borrar={this.activar}
                    icono={"exchange"}
                    texto={"Esta seguro que desea cambiar el esatus del registro?"}
                    titulo={this.state.strings?this.state.strings["CursoOpinion"]:""}
                 />

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
         listado:state.cursoopinion,
         showSidebarIzquierda: state.showSidebarIzquierda,
  sidebarIzquierda: state.sidebarIzquierda, 
          ajaxCallInProgress:state.ajaxCallInProgress,
         color:state.color,
		  permisos:state.permisos,
strings:state.strings, 
         form:state.form,
user:state.user, 
idioma:state.idioma,
    }

}

function mapDispatchToProps(dispatch){

	return {   
  showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
paginaActions: bindActionCreators(paginaActions, dispatch),
			listadoActions: bindActionCreators(cursoopinionActions, dispatch),
			load:bindActionCreators(cursoopinionActions.getCursoOpinionList, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageCursoOpinionList);